import { render, staticRenderFns } from "./ActivitgoodsList.vue?vue&type=template&id=77c7389f&"
import script from "./ActivitgoodsList.vue?vue&type=script&lang=js&"
export * from "./ActivitgoodsList.vue?vue&type=script&lang=js&"
import style0 from "./ActivitgoodsList.vue?vue&type=style&index=0&id=77c7389f&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77c7389f')) {
      api.createRecord('77c7389f', component.options)
    } else {
      api.reload('77c7389f', component.options)
    }
    module.hot.accept("./ActivitgoodsList.vue?vue&type=template&id=77c7389f&", function () {
      api.rerender('77c7389f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/ActivitgoodsList.vue"
export default component.exports